// Client-side mirror of worker/lib/normalize.ts. Same rules so the
// autocomplete filter behaves consistently with server-side matching.
//
// Egyptians type the same word many ways — ا vs أ vs إ vs آ, ي vs ى,
// ه vs ة, with or without diacritics. Normalize before comparing.

const ARABIC_DIACRITICS = /[ً-ْٰ]/g
const TATWEEL = /ـ/g
const ALEF_VARIANTS = /[أإآا]/g
const YA_VARIANTS = /[ىي]/g
const TA_MARBUTA = /ة/g
const WAW_HAMZA = /ؤ/g
const YA_HAMZA = /ئ/g
const HAMZA = /ء/g
const WHITESPACE = /\s+/g
const PUNCT = /[.,،؛؟!?'""«»\-_/\\()[\]{}]/g

export function normalizeArabic(s: string): string {
  return s
    .replace(ARABIC_DIACRITICS, '')
    .replace(TATWEEL, '')
    .replace(ALEF_VARIANTS, 'ا')
    .replace(YA_VARIANTS, 'ي')
    .replace(TA_MARBUTA, 'ه')
    .replace(WAW_HAMZA, 'و')
    .replace(YA_HAMZA, 'ي')
    .replace(HAMZA, '')
    .replace(PUNCT, ' ')
    .replace(WHITESPACE, ' ')
    .trim()
    .toLowerCase()
}
